import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=0f75c01a&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=0f75c01a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75c01a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f75c01a')) {
      api.createRecord('0f75c01a', component.options)
    } else {
      api.reload('0f75c01a', component.options)
    }
    module.hot.accept("./DocumentList.vue?vue&type=template&id=0f75c01a&scoped=true", function () {
      api.rerender('0f75c01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/DocumentList.vue"
export default component.exports